import React from "react";
import { ArrowRight, Droplets } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function GuidingYourWayHome() {
  return <section data-section-id="224129" id="guiding-your-way-home" className="relative w-full bg-background overflow-hidden">
      {}
      <div className="absolute bottom-0 right-0 w-full md:w-2/3 h-full pointer-events-none opacity-[0.03] text-primary z-0">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full absolute bottom-[-20%] right-[-10%] animate-pulse" style={{
        animationDuration: "8s"
      }}>
          <path fill="currentColor" d="M44.7,-76.4C58.8,-69.2,71.8,-59.1,81.3,-46.3C90.8,-33.5,96.8,-18,96.5,-2.8C96.2,12.4,89.5,27.3,80.1,40.4C70.7,53.5,58.6,64.8,44.5,72.8C30.4,80.8,15.2,85.5,0.1,85.3C-15,85.1,-30,80,-43.3,71.7C-56.6,63.4,-68.2,51.9,-76.5,38.5C-84.8,25.1,-89.8,9.8,-88.9,-5.2C-88,-20.2,-81.2,-34.9,-71.5,-46.7C-61.8,-58.5,-49.2,-67.4,-35.5,-74.2C-21.8,-81,-7.2,-85.7,7.1,-86.6C21.4,-87.5,30.6,-83.6,44.7,-76.4Z" transform="translate(100 100) scale(1.2)" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32 flex flex-col lg:flex-row items-center gap-16 relative z-10">
        
        {}
        <div className="w-full lg:w-3/5 flex flex-col items-start gap-8">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-accent text-primary font-default text-sm font-semibold mb-2">
            <Droplets className="w-4 h-4" />
            <span>Premier Mortgage Solutions</span>
          </div>
          
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold font-default text-primary leading-[1.1] tracking-tight">
            Guiding Your <br className="hidden sm:block" />
            <span className="font-normal italic text-foreground/80">
              Way Home
            </span>
          </h1>
          
          <p className="text-lg sm:text-xl text-foreground font-default max-w-2xl leading-relaxed">
            Beacon Finance Group provides the clarity and expertise you need to navigate the mortgage landscape. From refinancing to home equity, we secure your future with precision.
          </p>
          
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 mt-4 w-full sm:w-auto">
            <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20 transition-all duration-300 hover:scale-105 hover:shadow-primary/30 rounded-md text-base h-14 px-8 group">
              <Link to="/LendingSolutionsPage">
                Get Started
                <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
            
            <Link to="/LendingSolutionsPage" className="text-primary font-default font-semibold text-base flex items-center gap-2 hover:text-primary/80 transition-colors py-2 group border-2 border-primary px-6 rounded-md h-14">
              <span className="relative">
                View Rates
              </span>
            </Link>
          </div>
        </div>

        {}
        <div className="w-full max-w-md lg:max-w-none lg:w-2/5 relative">
          {}
          <div className="absolute inset-0 bg-primary/5 rounded-md transform translate-x-4 translate-y-4 -z-10"></div>
          
          <div className="relative w-full shadow-2xl rounded-md overflow-hidden border-4 border-background">
            <AspectRatio ratio={4 / 5}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686387/img/modern_architectural_home_exterior.png" alt="Modern architectural home with floor-to-ceiling glass" className="w-full h-full object-cover desaturate-[0.2]" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent mix-blend-overlay"></div>
            </AspectRatio>
          </div>
          
          {}
          <div className="absolute -bottom-6 -left-6 bg-background p-4 rounded-md shadow-xl border border-border flex items-center gap-4 animate-bounce" style={{
          animationDuration: '3s'
        }}>
            <div className="w-12 h-12 rounded-md bg-accent flex items-center justify-center text-primary">
              <Droplets className="w-6 h-6" />
            </div>
            <div className="flex flex-col">
              <span className="font-bold font-default text-primary">Expert</span>
              <span className="text-sm font-default text-foreground">Guidance</span>
            </div>
          </div>
        </div>

      </div>
    </section>;
}